<script>
	import router from "../stores/router";
	import { tick } from "svelte";

	const tags = "#クリエイティブエイジング #ずっとび";
	let title = "";
	let url = "";
	$: {
		$router.path;
		tick().then(() => {
			url = location.href;
			title = document.title;
		});
	}
</script>

<nav class="UIShare">

	<a
		target="_blank"
		href="https://twitter.com/share?text={title}&url={url}&hashtags={tags}"
		><img src="/img/sns-twitter.png" alt="Share by Twitter" /></a
	>
	<a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u={url}"
	><img src="/img/sns-facebook.png" alt="Share by Facebook" /></a
>
	<a
		target="_blank"
		href="https://social-plugins.line.me/lineit/share?url={url}"
		><img src="/img/sns-line.png" alt="Share by LINE" /></a
	>
</nav>

<style global>
	.UIShare {
		padding: 2.5em 0 1em;
		text-align: center;
	}
	.UIShare a {
		margin: 0 0.75em;
		opacity: 0.9;
		transition: opacity 100ms linear;
		border: 1px dashed transparent;
		padding-bottom: 0.25em;
		display: inline-block;
	}
	.UIShare a:hover {
		opacity: 1;
	}
	.UIShare a:focus-visible {
		border-color: #fff;
	}
	.UIShare img {
		width: 50px;
	}
</style>
